/****************************************************************************************************************
 * ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
 *
 * The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
 * other pending or existing intellectual property rights in India, the United States and other countries. The Program
 * may contain / reference third party or open source components, the rights to which continue to remain with the
 * applicable third party licensors or the open source community as the case may be and nothing here transfers the
 * rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
 * storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
 * photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
 * severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
 *****************************************************************************************************************/
import { environment } from '../../environments/environment';
export const config = {
  // All fields are mandatory
  headerTitle: 'Nia Supplier portal',
  hasChatBox: false, // If chatBox component needs be displayed
  hasFooter: true, // If footer component needs be displayed
  chatInLeft: true,
  tsmApiPath: environment.baseContext + '/tsmapi/',
  authApiPath: environment.baseContext + '/authapi/',
  language: 'en_us',

  id: 5,
  menus: [],
  icons: [
    // icons available - id:homeIcon, id:cartIcon, id:profileIcon, id:inboxIcon, id: notificationIcon
    {
      id: 'inboxIcon',
      path: 'sample/inbox',
      action: 'navigate',
      required: false,
      iconText: '',
      iconBadge: false
    },
    {
      id: 'profileIcon',
      action: 'overlay',
      required: true,
      iconText: '',
      iconBadge: false
    },
    {
      id: 'cartIcon',
      action: 'overlay',
      required: false,
      iconText: '',
      iconBadge: true
    },
    {
      id: 'homeIcon',
      path: 'sup/',
      action: 'navigate',
      required: false,
      iconText: '',
      iconBadge: false
    },
    {
      id: 'chatIcon',
      path: '',
      action: 'chat',
      required: false,
      iconText: '',
      iconBadge: true,
      isMenuOpen: false
    },
    {
      id: 'appSwitcherIcon',
      path: '/appSwitcher',
      action: 'overlay',
      required: true,
      iconText: '',
      iconBadge: true
    }
  ],
  staticMenuOptions: [
    {
      name: 'My Profile',
      link: '/sup/user-profile/view'
    }
  ],


  MAX_TAXONOMY_LEVELS: 5,
  ATTACHMENTS_MAX_NUM: 3,
  ATTACHMENTS_MAX_SIZE_BYTES: 10485760,
  ATTACHMENTS_ALLOWED_EXTENSIONS: ['xlsx', 'json', 'txt', 'text/plain', 'pdf', 'png', 'jpg', 'avi', 'mp4', 'ppt',
    'pptx', 'xls', 'xlsx', 'doc', 'docx', 'pdf', 'avi', 'wmv', 'flv', 'mpeg', 'mp4', 'quicktime', 'h.264', 'divx',
    'vdo', 'mov', 'mp3', 'wav', 'wma', 'mpeg', 'png', 'jpg', 'gif', 'jpeg', 'bmp'],
  ERR_ATTACHMENTS_MAX_NUM: 'Cannot Upload More Than 3 Attachments',
  ERR_ATTACHMENTS_MAX_SIZE_BYTES: 'Attachment Size Should Not Exceed 10Mb',
  ERR_ATTACHMENTS_ALLOWED_EXTENSIONS: 'Unsupported File Type Detected',
  MSP_Email: 'batsmsp@testsmtp.com',
  MAX_MSP_QUESTIONS: 5,
  MAX_FILE_ATTACHMENTS: 3,
  MAX_EMAIL_CONTENT_LENGTH: 10000,
  EditDisabled: {
    email: true,
    phoneNumber: false,
    firstName: true,
    lastName: false,
    location: true
  },
  convertMinsToHrsMins: function convertMinsToHrsMins(mins) {
    let h = Math.floor(mins / 60);
    let m = mins % 60;
    return '${padDigits(h, 2)}${padDigits(m, 2)}';
    function padDigits(number, digits) {
      return Array(Math.max(digits - String(number).length + 1, 0)).join('0') + number;
    }
  }
};


